import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NumberStepper',
    props: {
        currentStep: null,
        steps: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step) => {
                    return _withDirectives((_openBlock(), _createElementBlock("span", {
                        key: step.number,
                        class: _normalizeClass(["inline-block mr-8 capitalize",
                            __props.currentStep === step.number
                                ? 'text-primary-100 dark:text-gray-300 text-xl'
                                : 'text-primary-400 dark:text-gray-400 text-sm'
                        ])
                    }, _toDisplayString(step.number) + ". " + _toDisplayString(step.title), 3)), [
                        [_vShow, step.number >= __props.currentStep]
                    ]);
                }), 128))
            ]));
        };
    }
});
